import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';
import { TooltipModule, PopoverModule } from 'ngx-bootstrap';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { EmailHtmlEditorModule } from 'src/app/shared/email-html-editor/email-html-editor.module';
import { IncludeDetailsCheckboxesModule } from 'src/app/shared/include-details-checkboxes/include-details-checkboxes.module';
import { EmailDocumentsComponent } from './email-documents.component';

@NgModule({
  declarations: [EmailDocumentsComponent],
  imports: [
    CommonModule,
    FormsModule,
    TagInputModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    PipesModule,
    EmailHtmlEditorModule,
    IncludeDetailsCheckboxesModule,
    DropzoneModule
  ],
  exports: [EmailDocumentsComponent],
  entryComponents: [EmailDocumentsComponent]
})
export class EmailDocumentsModule { }
